import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import logo from '@/assets/logo.svg';

const sizeClasses = {
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
  xl: 'w-12 h-12',
};

interface BrandedLoaderProps {
  message?: string;
  size?: 'md' | 'lg' | 'xl';
  className?: string;
  fullPage?: boolean;
}

/**
 * Full container loading state with branded W logo + optional message
 * Use for page-level loading, replacing Loader2 spinners in full-page contexts
 */
export function BrandedLoader({
  message,
  size = 'lg',
  className,
  fullPage = false,
}: BrandedLoaderProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        fullPage ? 'min-h-screen' : 'flex-1 py-16',
        className
      )}
      role="status"
      aria-label={message || 'Loading'}
    >
      <motion.div
        className="relative"
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.7, 1, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      >
        <img src={logo} alt="" className={sizeClasses[size]} />
      </motion.div>
      
      {message && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mt-3 text-sm text-muted-foreground"
        >
          {message}
        </motion.p>
      )}
    </div>
  );
}
